export default __webpack_public_path__ + "static/media/4.c1d7e7a6.jpg";